module.exports = __webpack_public_path__ + "static/img/jingluotitle.1b946aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jingluotitle.png
// module id = oeQe
// module chunks = 1